import { render, staticRenderFns } from "./receive-product.vue?vue&type=template&id=31cdbb04&scoped=true&"
import script from "./receive-product.vue?vue&type=script&lang=js&"
export * from "./receive-product.vue?vue&type=script&lang=js&"
import style0 from "./receive-product.vue?vue&type=style&index=0&id=31cdbb04&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31cdbb04",
  null
  
)

export default component.exports